module.exports = __webpack_public_path__ + "img/title-bg.6a6fe350.png";